import { ColorOption } from 'src/enums/color-option';
import { colors } from 'src/styling/constants';

export const getColorForOption = (option: ColorOption | null | undefined): string | undefined => {
  if (!option) {
    return undefined;
  }

  switch (option) {
    case ColorOption.WHITE:
      return '#fff';
    case ColorOption.CHARCOAL:
      return colors.capeCod;
    case ColorOption.BLACK:
      return '#000';
    case ColorOption.DARK_BROWN:
      return colors.davidLloydBrown;
    case ColorOption.DARK_GREY:
      return colors.harbourSlateGrey;
    case ColorOption.GOLD:
      return colors.harbourGold;
    case ColorOption.RED:
      return colors.alert;
    case ColorOption.TEAL:
      return colors.davidLloydTeal;
    case ColorOption.PURPLE:
      return colors.davidLloydPurple;
  }
};
